<template>
    <v-container fluid class="mb-4">
        <v-toolbar text dark color="secondary">
            <v-toolbar-title>Lista de escolas</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                    <v-btn text v-on="on" v-if="isAdmin">
                        <v-icon left>add</v-icon>
                        Adicionar escola
                    </v-btn>
                </template>
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-text-field v-model="editedItem.nome" label="Nome" :rules="[inputRules.required, inputRules.minChars]"></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-select v-model="editedItem.concelho" label="Concelho" :items="concelhos" :rules="[inputRules.required]" v-on:change="loadFreguesias(editedItem.concelho)"></v-select>
                                </v-flex>
                                <v-flex xs12>
                                    <v-select v-model="editedItem.localizacao" label="Localização" :items="freguesias" :rules="[inputRules.required]"></v-select>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field v-model="editedItem.morada" label="Morada"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field v-model="editedItem.telefone" label="Telefone"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field v-model="editedItem.fax" label="Fax"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field v-model="editedItem.email" label="E-mail" :rules="[inputRules.email]" hint="conta@dominio.extensao"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field v-model="editedItem.site" label="Site" :rules="[inputRules.url]" hint="http(s)://dominio.extensao"></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" text @click="resetEditedData">Cancelar</v-btn>
                        <v-btn color="secondary" text @click="save">Gravar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

			<!-- TODO: usar componente para ConfirmDialog -->
			<!-- <ConfirmDialog :message="'Tem a certeza de que pretende apagar os dados desta escola?'" :model="showConfirm"></ConfirmDialog> -->
			<v-dialog v-model="showConfirm" persistent max-width="400">
				<v-card>
					<v-card-title class="headline">Atenção</v-card-title>
					<v-card-text>Tem a certeza de que pretende apagar os dados desta escola?</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="secondary" text @click="showConfirm = false">Cancelar</v-btn>
						<v-btn color="secondary" text @click="deleteConfirmed(editedItem); showConfirm = false;">Confirmar</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
        </v-toolbar>

		<v-layout class="pt-4 align-center">
			<v-flex xs3>
				<v-select
					v-model="concelhoSeleccionado"
					:items="concelhos"
					v-on:change="loadEscolas(concelhoSeleccionado)"
					label="Concelho"
					:readonly="concelhos.length <= 1"
					outlined>
				</v-select>
			</v-flex>
			<!-- <v-flex xs3>
				<v-btn
					color="secondary" text
					@click="loadEscolas(concelhoSeleccionado)"
					:disabled="!concelhoSeleccionado">
					Pesquisar
				</v-btn>
			</v-flex> -->
		</v-layout>

		<v-container v-if="!isLoading && escolas.length === 0">
			<p class="text-center py-8">{{ searched ? 'Sem escolas registadas.' : 'Indique o concelho pretendido.'}}</p>
		</v-container>

		<v-list two-line v-if="escolas.length > 0">
			<template v-for="(item, index) in escolas">
				<div :key="item.id">
					<v-list-item :key="item.id" @click="goToTurmas(item.id)">
						<v-list-item-content>
							<v-list-item-title>{{ item.nome }} </v-list-item-title>
							<v-list-item-subtitle>{{ item.morada }} </v-list-item-subtitle>
							<v-list-item-subtitle>
								<span v-if="item.telefone">Tel: <strong>{{ item.telefone }}</strong>&nbsp;&nbsp;</span>
								<span v-if="item.fax">Fax: <strong>{{ item.fax }}</strong>&nbsp;&nbsp;</span>
								<span v-if="item.email">E-mail: <strong>{{ item.email }}</strong>&nbsp;&nbsp;</span>
								<span v-if="item.site">Site: <strong>{{ item.site }}</strong></span>
							</v-list-item-subtitle>
						</v-list-item-content>

						<v-list-item-action>
							<div>
								<v-tooltip bottom>
									<template v-slot:activator="{ on }">
										<v-btn icon ripple class="mx-2" v-on="on" v-if="isAdmin" @click="editItem(item)" @click.stop="">
											<v-icon color="secondary">edit</v-icon>
										</v-btn>
									</template>
									<span>Editar</span>
								</v-tooltip>
								<v-tooltip bottom>
									<template v-slot:activator="{ on }">
										<v-btn icon ripple class="mx-2" v-on="on" v-if="isAdmin" @click="deleteItem(item)" @click.stop="">
											<v-icon color="secondary">delete</v-icon>
										</v-btn>
									</template>
									<span>Eliminar</span>
								</v-tooltip>
								<v-tooltip bottom>
									<template v-slot:activator="{ on }">
										<v-btn icon ripple class="mx-2" v-on="on" @click="goToTurmas(item.id)" @click.stop="">
											<v-icon color="secondary">group</v-icon>
										</v-btn>
									</template>
									<span>Turmas</span>
								</v-tooltip>
							</div>
						</v-list-item-action>
					</v-list-item>

					<v-divider :key="index" v-if="index < escolas.length-1"></v-divider>
				</div>
			</template>
		</v-list>

		<Loading :isLoading="isLoading" />

		<error-dialog :show-dialog="this.errorMessage.show" :error-message="this.errorMessage"></error-dialog>
    </v-container>
</template>

<script>
	import UserService from '@/services/user.service';
	const userService = new UserService();

	import Loading from "@/components/Loading";

    export default {
		components: {
			Loading
		},

        data: () => ({
			dialog: false,
			errorMessage: {
				show: false
			},
			showConfirm: false,
			isLoading: false,
			concelhos: [], // to be loaded on created
			freguesias: [], // to be loaded on created
			escolas: [], // to be loaded on created
			concelhoSeleccionado: null,
			searched: false,
            editedIndex: -1,
            editedItem: {
                nome: '',
                morada: '',
                telefone: '',
                fax: '',
                email: '',
                site: '',
            },
            defaultItem: {
                nome: '',
                morada: '',
                telefone: '',
                fax: '',
                email: '',
                site: '',
            },
            inputRules: {
                required: value => !!value || 'Campo obrigatório',
                minChars: value => value.length >= 3 || 'Deverá conter pelo menos 3 caracteres',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return !value || pattern.test(value) || 'Endereço de e-mail inválido'
                },
                url: value => {
                    const pattern = /^(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})$/
                    // const pattern = /^(https?|ftp)://[^\s/$.?#].[^\s]*$/
                    // const pattern = /^(http[s]?:\/\/(www\.)?|ftp:\/\/(www\.)?|www\.){1}([0-9A-Za-z-.@:%_+~#=]+)+((\.[a-zA-Z]{2,3})+)(\/(.)*)?(\?(.)*)?$/
                    // const pattern = /^(?:(?:https?)://)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\x{00a1}-\x{ffff}0-9]+-?)*[a-z\x{00a1}-\x{ffff}0-9]+)(?:\.(?:[a-z\x{00a1}-\x{ffff}0-9]+-?)*[a-z\x{00a1}-\x{ffff}0-9]+)*(?:\.(?:[a-z\x{00a1}-\x{ffff}]{2,})))(?::\d{2,5})?(?:/[^s]*)?$/
                    // const pattern = /[-a-zA-Z0-9@:%_+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_+.~#?&//=]*)?/gi;
                    
                    return !value || pattern.test(value) || 'URL inválido'
                }
            }
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Adicionar escola' : 'Editar escola'
            },
			isAdmin () {
				return userService.isAdmin();
			}
        },

        watch: {
            dialog (val) {
                val || this.resetEditedData()
            }
        },

        created () {
			this.loadConcelhos();
        },

        methods: {
			loadConcelhos () {
				this.isLoading = true;

				var currentUser = userService.getUserId();

				this.$http.get(process.env.VUE_APP_API_ROOT + `/concelho/?utilizador=${currentUser}`).then(function(data){
                    return data.json();
                }).then(function(data){
                    var arrayConcelhos = [];
                    data.forEach (item => {
                        arrayConcelhos.push({ value: item.id, text: item.nome});
                    });
					this.concelhos = arrayConcelhos;
					
					if (arrayConcelhos.length === 1) {
						this.concelhoSeleccionado = arrayConcelhos[0].value;

						this.loadEscolas(this.concelhoSeleccionado);
					}

					this.isLoading = false;
                }, response => { // error callback
					this.isLoading = false;
				});
			},
			loadFreguesias (concelho) {
				this.isLoading = true;

				this.$http.get(process.env.VUE_APP_API_ROOT + `/freguesia/?concelho=${concelho}`).then(function(data){
                    return data.json();
                }).then(function(data){
                    var arrayFreguesias = [];
                    data.forEach (item => {
                        arrayFreguesias.push({ value: item.id, text: item.nome});
                    });
                    this.freguesias = arrayFreguesias;

					this.isLoading = false;
                }, response => { // error callback
					this.isLoading = false;
				});
			},
			loadEscolas (concelho) {
				this.isLoading = true;

				this.searched = true;

				this.$http.get(process.env.VUE_APP_API_ROOT + `/escola/?concelho=${concelho}`).then(function(data){
                    return data.json();
                }).then(function(data){
                    // console.log(data);
					this.escolas = data;

					this.isLoading = false;
                }, response => { // error callback
					this.isLoading = false;
				});
			},
            editItem (item) {
                this.editedIndex = this.escolas.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },
            deleteItem (item) {
                this.editedIndex = this.escolas.indexOf(item)
                this.editedItem = Object.assign({}, item)
				this.showConfirm = true;
            },
            resetEditedData () {
                this.dialog = false;
				this.editedItem = Object.assign({}, this.defaultItem);
				this.editedIndex = -1;
            },
            save () {
				this.isLoading = true;

                if (this.editedIndex > -1) {
					console.log(this.editedItem);
					this.$http.put(process.env.VUE_APP_API_ROOT + `/escola/${this.editedItem.id}/`, this.editedItem).then(function(data){
						console.log(data);
						this.submitted = true;

						Object.assign(this.escolas[this.editedIndex], this.editedItem);
						
						this.resetEditedData();

						this.isLoading = false;
					}, response => { // error callback
						console.log(response);

						this.errorMessage.message = "Ocorreu um erro ao editar os dados da escola.";
						this.errorMessage.show = true;

						this.isLoading = false;
					});
                } else {
					this.$http.post(process.env.VUE_APP_API_ROOT + '/escola/', this.editedItem).then(function(data){
						console.log(data);
						this.submitted = true;
						
						this.escolas.push(data.body);
						
						this.resetEditedData();

						this.isLoading = false;
					}, response => { // error callback
						console.log(response);

						this.errorMessage.message = "Ocorreu um erro ao gravar os dados da nova escola.";
						this.errorMessage.show = true;

						this.isLoading = false;
					});
                }
			},
			deleteConfirmed (item) {
				this.isLoading = true;

				console.log(item)
				this.$http.delete(process.env.VUE_APP_API_ROOT + `/escola/${item.id}/`).then(function(data){
					console.log(data);
					this.submitted = true;

					const index = this.escolas.indexOf(item);
					this.escolas.splice(index, 1);

					this.isLoading = false;
				}, response => { // error callback
					console.log(response);

					this.errorMessage.message = "Ocorreu um erro ao eliminar os dados da escola.";
					this.errorMessage.show = true;

					this.isLoading = false;
				});
			},
            goToTurmas (escola_id) {
                this.$router.push({ name: 'lista-turmas', params: { escolaId: escola_id }})
            }
        }
    }
</script>